import { FunctionComponent, useState } from "react";
import { Dialog, Box, Button as MuiButton, Stack, Typography, SvgIcon, CircularProgress } from "@mui/material";
import { Button } from "../../../Button";
import { CustomInput } from "../../../CustomInput";
import RttIcon from '@mui/icons-material/Rtt';
import { Icon } from "@mdi/react";
import { IProps } from "./IProps";
import { useNewInputDialog } from "./hook";

export const NewInputDialog: FunctionComponent<IProps> = (props): JSX.Element => {
    const { open, isLoading, onClick, onClose } = props;
    const { onChange, onCleanForm, state } = useNewInputDialog();

    return (
        <Dialog open={open}>
            <Box position="relative" display="flex" flexDirection="column" alignItems="start" justifyContent="space-between" width={550} height={227} borderRadius="15px" bgcolor="white" padding={4}>
                {isLoading && (
                    <Box
                        sx={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1, position: "absolute", top: 0, left: 0 }}
                    >
                        <CircularProgress color="primary" />
                    </Box>
                )}
                <Stack direction="row" alignItems="center" spacing={2}>
                    <SvgIcon htmlColor="#1BA0E9" fontSize="large" >
                        <RttIcon />
                    </SvgIcon>
                    <Typography sx={{ color: "rgba(0, 0, 0, 0.8)", fontWeight: 600, fontSize: 22 }}>
                        New Form Field
                    </Typography>
                </Stack>
                <Box display="flex" alignItems="center" gap={2} width="100%" mt={2} >
                    <CustomInput
                        width={220}
                        height={35}
                        value={state.parameterName}
                        name="parameterName"
                        placeholder="name"
                        startIcon={<RttIcon />}
                        onChange={onChange}
                    />
                    <CustomInput
                        width={220}
                        height={35}
                        value={state.parameterValue}
                        name="parameterValue"
                        placeholder="Value"
                        startIcon={<RttIcon />}
                        onChange={onChange}
                    />
                </Box>
                <Stack width="100%" direction="row" display="flex" alignItems="center" justifyContent="flex-end" spacing={4} mt={2}>
                    <MuiButton 
                        variant="text" 
                        sx={{ fontWeight: 700, fontFamily: "Lato", fontSize: 16, color: "#1BA0E9" }} 
                        onClick={() => {
                            onCleanForm();
                            onClose!();
                        }} 
                    >
                        Cancel
                    </MuiButton>
                    <Button
                        label="Save"
                        width={120}
                        height={40}
                        onClick={() => {
                            onClick!(state.parameterName, state.parameterValue);
                            onCleanForm();
                        }}
                    />
                </Stack>
            </Box>
        </Dialog>
    )
}